import { SelectionItem } from '../../../core/component/select/select.component';

export enum IntervalKind {
  None = 0,
  Day = 1,
  Week = 2,
  Month = 3,
  Year = 4,
}

export const DaysOfWeekFlags = {
  All: 0,
  Monday: 1 << 0,
  Tuesday: 1 << 1,
  Wednesday: 1 << 2,
  Thursday: 1 << 3,
  Friday: 1 << 4,
  Saturday: 1 << 5,
  Sunday: 1 << 6,
};

export enum ErrandStatus {
  Draft = 1,
  New = 2,
  Registered = 3,
  Started = 4,
  /** This status should NOT be used for RoundingErrands */
  Executed = 5,
  Closed = 6,
  Cancelled = 7,
}

export enum ErrandType {
  Rounding = 1,
  Deviation = 2,
  AuthorityInspection = 3,
  FaultNotification = 4,
  DwellingInspection = 5,
  TenantRequest = 6,
  GenericErrand = 7
}

export enum ErrandAttachmentConnectionKind {
  General = 0,
}

export const ERRAND_STATUS_COMPLETED: ErrandStatus[] = [
  ErrandStatus.Executed,
  ErrandStatus.Closed,
  ErrandStatus.Cancelled];
const UNIT_ERROR = 'Invalid entry unit.';

// TODO: config
export function ChecklistIntervalKindToString(interval: IntervalKind) {
  switch (interval) {
    case IntervalKind.Day:
      return 'Day';

    case IntervalKind.Week:
      return 'Week';

    case IntervalKind.Month:
      return 'Month';

    case IntervalKind.Year:
      return 'Year';

    default:
      return new Error(UNIT_ERROR);
  }
}

export function GetErrandStatusDeviationSelectItems(): SelectionItem[] {
  return [
    new SelectionItem(ErrandStatusToString(ErrandStatus.Draft), ErrandStatus.Draft),
    new SelectionItem(ErrandStatusToString(ErrandStatus.New), ErrandStatus.New),
    new SelectionItem(ErrandStatusToString(ErrandStatus.Registered), ErrandStatus.Registered),
    new SelectionItem(ErrandStatusToString(ErrandStatus.Started), ErrandStatus.Started),
    new SelectionItem(ErrandStatusToString(ErrandStatus.Executed), ErrandStatus.Executed),
    new SelectionItem(ErrandStatusToString(ErrandStatus.Closed), ErrandStatus.Closed),
    new SelectionItem(ErrandStatusToString(ErrandStatus.Cancelled), ErrandStatus.Cancelled),
  ];
}

export function GetErrandStatusRoundingSelectItems(): SelectionItem[] {
  return [
    new SelectionItem(ErrandStatusToString(ErrandStatus.Draft), ErrandStatus.Draft),
    new SelectionItem(ErrandStatusToString(ErrandStatus.New), ErrandStatus.New),
    new SelectionItem(ErrandStatusToString(ErrandStatus.Registered), ErrandStatus.Registered),
    new SelectionItem(ErrandStatusToString(ErrandStatus.Started), ErrandStatus.Started),
    //new SelectionItem(ErrandStatusToString(ErrandStatus.Executed), ErrandStatus.Executed),
    new SelectionItem(ErrandStatusToString(ErrandStatus.Closed), ErrandStatus.Closed),
    new SelectionItem(ErrandStatusToString(ErrandStatus.Cancelled), ErrandStatus.Cancelled),
  ];
}

export function DaysOfWeekToString(flags) {
  const selectedDays = Object.keys(DaysOfWeekFlags)
    .filter(key => flags & DaysOfWeekFlags[key])
    .map(key => `CONST.WEEKDAYS.${key.toUpperCase()}`)
    .join(', ');

  return selectedDays || 'All';
}

export function DaysOfWeekToShortString(flags) {
  const selectedDays = Object.keys(DaysOfWeekFlags)
    .filter(key => flags & DaysOfWeekFlags[key])
    .map(key => `CONST.WEEKDAYS.${key.slice(0, 3).toUpperCase()}`)
    .join(', ');

  return selectedDays || 'All';
}

const ERRANDSTATUS_ERROR = 'Invalid errand status.';
export function ErrandStatusToString(errandStatus: ErrandStatus): string {
  switch (errandStatus) {
    case ErrandStatus.Draft:
      return 'CONST.ERRANDSTATUS.DRAFT';
    case ErrandStatus.New:
      return 'CONST.ERRANDSTATUS.NEW';
    case ErrandStatus.Registered:
      return 'CONST.ERRANDSTATUS.REGISTERED';
    case ErrandStatus.Started:
      return 'CONST.ERRANDSTATUS.STARTED';
    case ErrandStatus.Executed:
      return 'CONST.ERRANDSTATUS.EXECUTED';
    case ErrandStatus.Closed:
      return 'CONST.ERRANDSTATUS.CLOSED';
    case ErrandStatus.Cancelled:
      return 'CONST.ERRANDSTATUS.CANCELLED';
    default:
      throw new Error(ERRANDSTATUS_ERROR);
  }
}

const ERRANDTYPE_ERROR = 'Invalid errand type.';
export function ErrandTypeToString(errandType: ErrandType): string {
  switch (errandType) {
    case ErrandType.Rounding:
      return 'CONST.ERRANDTYPE.ROUNDING';
    case ErrandType.Deviation:
      return 'CONST.ERRANDTYPE.DEVIATION';
    case ErrandType.AuthorityInspection:
      return 'CONST.ERRANDTYPE.AUTHORITY_INSPECTION';
    case ErrandType.FaultNotification:
      return 'CONST.ERRANDTYPE.FAULT_NOTIFICATION';
    case ErrandType.DwellingInspection:
      return 'CONST.ERRANDTYPE.DWELLING_INSPECTION';
    case ErrandType.TenantRequest:
      return 'CONST.ERRANDTYPE.TENANT_REQUEST';
    case ErrandType.GenericErrand:
      return 'CONST.ERRANDTYPE.GENERIC_ERRAND';
    default:
      throw new Error(ERRANDTYPE_ERROR);
  }
}

const ERRANDCONNECTIONKIND_ERROR = 'Invalid errand attachment connection kind.';
export function ErrandAttachmentConnectionKindToString(errandType: ErrandAttachmentConnectionKind): string {
  switch (errandType) {
    case ErrandAttachmentConnectionKind.General:
      return 'CONST.ERRANDTYPE.GENERAL';
    default:
      throw new Error(ERRANDCONNECTIONKIND_ERROR);
  }
}
